import { render, staticRenderFns } from "./chartererVsoa.vue?vue&type=template&id=acbe976a"
import script from "./chartererVsoa.vue?vue&type=script&lang=js"
export * from "./chartererVsoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports